'use strict';

import {ngDepModel} from './ngdepmodel.js';
import {reportingModel} from './reportingmodel.js';

export class financingRequestModel extends ngDepModel
{
		
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	getValue(name){
		switch(name){
			case 'estimated':
				return this.s('$filter')('currency')(this[name]);
			case 'requested':
				return this.s('$filter')('currency')(this[name]);
			case 'initial':
				return this.s('$filter')('currency')(this[name]);
			case 'consumption':
				return this.s('$filter')('currency')(this[name]);
			case 'consumption_pc':
				return this.s('$filter')('suffix')(
					this.s('$filter')('currency')(this[name]),
					' %'
				);
			case 'contract_amount':
				return this.s('$filter')('currency')(this[name]);
			case 'status':
				return this.getClassifValue(name, 'payment_status');
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
	
	afterSetup(data){
		if(typeof(this.contract_reporting) !== 'undefined'){
			this.contract_reporting = new reportingModel(this.contract_reporting, this.s('$filter'), this.s('jsDataService'));
			this.payment_type_id = this.contract_reporting.payment_type_id;
		}
		this.setF2Number('consumption');
		this.setF2Number('estimated');
		this.setF2Number('requested');
		this.setF2Number('initial');
		this.setF2Number('consumption_pc');
		this.setF2Number('contract_amount');
//		if(typeof(this.consumption) !== 'undefined' && !isNaN(this.consumption)){
//			this.consumption = Number(parseFloat(this.consumption).toFixed(2));
//		}
//		else{
//			this.consumption = Number(0.00);
//		}
		this.makeCetField('guarantee_receipt_date', true);
		this.guarantee_receipt_date_cet.setHours(12);
		this.makeCetField('paid_date', true);
		this.paid_date_cet.setHours(12);
		if(this.status < 1){
			this.calcFinancing();
		}
	}
	
	setF2Number(name){
		if(typeof(this[name]) !== 'undefined' && !isNaN(this[name])){
			this[name] = Number(parseFloat(this[name]).toFixed(2));
		}
		else{
			this[name] = Number(0.00);
		}
	}
	
	calcFinancing(){
		if(this.payment_type_id == 1){
			this.calcInitialFinancing();
		}
		else if(this.payment_type_id == 2){
			this.calcSecondFinancing();
		}
		else if(this.payment_type_id == 9){
			this.calcFinalFinancing();
		}
	}
	
	calcInitialFinancing(){
		this.consumption_pc = 0;
		if(this.initial > 0 && this.consumption > 0){
			this.consumption_pc = Number(parseFloat((this.consumption * 100) / this.initial).toFixed(2));
			if(this.consumption_pc < 70){
				this.requested = Number(parseFloat(this.contract_amount - ((this.initial * 0.7) - this.consumption)).toFixed(2));
			}
			else{
				this.requested = this.contract_amount;
			}
		}
	}
	
	calcSecondFinancing(){
		this.calcInitialFinancing();
	}
	
	calcFinalFinancing(){
		this.calcInitialFinancing();
	}
	
}